import React from 'react';
import './OverviewBoard.css';

const OverviewBoardHeader = ({
  eyebrow,
  title,
  count,
  actionLabel,
  onAction,
  actionTitle,
}) => (
  <div className="overview-board__header">
    <div className="overview-board__titles">
      <p className="overview-board__eyebrow">{eyebrow}</p>
      <h3 className="overview-board__title">{title}</h3>
      {count ? <p className="overview-board__count">{count}</p> : null}
    </div>
    {onAction ? (
      <button
        type="button"
        className="overview-board__view"
        onClick={onAction}
        title={actionTitle || actionLabel}
      >
        {actionLabel}
      </button>
    ) : null}
  </div>
);

export default OverviewBoardHeader;
